import { createReducer, AnyAction } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import { caseEditsActions } from '../actions/case-edits';
import { getDetail } from '../actions/cases.action';
import { launchPageActions } from '@codametrix/ui-common';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const reducer = createReducer(InitialState.caseEdits, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.caseEdits }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.caseEdits }));

  builder.addCase(caseEditsActions.updateValue, (state, action) => {
    const { fieldKey, newValue } = action.payload;
    const { caseRun, caseEdits } = state;

    const initialVal = caseRun ? caseRun[fieldKey as keyof CMxAPI.CaseRun] : '';

    return {
      ...state,
      caseEdits: {
        ...caseEdits,
        [fieldKey]: {
          ...caseEdits[fieldKey],
          options: caseEdits[fieldKey]?.options ?? [],
          initialValue: initialVal,
          newValue,
          valueState: 'edit'
        }
      }
    };
  });

  builder.addCase('CASE_DETAIL/pending', () => {
    return { ...InitialState.caseEdits };
  });

  builder.addCase('CASE_DETAIL/fulfilled', (state, action: AnyAction) => {
    const result = action.payload;
    return {
      ...state,
      caseRun: result.caseRuns[0]
    };
  });

  builder.addCase(launchPageActions.caseRunAvailable.type, (state, action: AnyAction) => {
    return {
      ...state,
      caseRun: action.payload
    };
  });

  builder.addCase(launchPageActions.caseRunWithRefreshAvailable.type, (state, action: AnyAction) => {
    let caseRun = state?.caseRun;
    if (!!caseRun) {
      caseRun = {
        ...caseRun,
        patient_class:
          action.payload?.patient_class ?? caseRun?.patient_class,
        patient_type:
          action.payload?.patient_type ?? caseRun?.patient_type
      };
    }
    return {
      ...state,
      caseRun
    };
  });

  builder.addCase(caseEditsActions.loadAllPatientDetailOptions.pending, state => {
    return {
      ...state,
      caseEdits: InitialState.caseEdits.caseEdits
    };
  });

  builder.addCase(caseEditsActions.loadPatientDetailOptions.fulfilled, (state, action) => {
    const dictionary = action.meta.arg.dictionary;
    const result = action.payload;
    const { caseRun, caseEdits } = state;

    const initialValue = caseRun
      ? caseRun[dictionary as keyof CMxAPI.CaseRun]
      : '';

    const updatedCaseEdits = {
      ...caseEdits,
      [dictionary]: {
        options: result.standardFields.map(item => item.label),
        initialValue,
        newValue: '',
        valueState: 'edit',
        mappedValues: result.standardFields
      }
    };

    if (dictionary === 'patient_type') {
      updatedCaseEdits['patient_class'] = {
        options: result.additionalFields.map(item => item.label),
        initialValue,
        newValue: '',
        valueState: 'edit',
        mappedValues: result.additionalFields
      };
    }

    return {
      ...state,
      caseEdits: updatedCaseEdits
    };
  });
});

export default reducer;
